/** @format */
import styled from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { ProductComparisonItemHeader } from '../../product-comparison-item.styles';

export const ProductComparisonItemErrorHeader = styled(
    ProductComparisonItemHeader
)`
    ${theme.typography.body_small_highlight}
    grid-template-columns: 1fr;
    justify-items: center;
    white-space: nowrap;

    .product-comparison-item-error-message {
        align-self: end;
    }

    .product-comparison-item-refresh-button {
        align-self: start;
    }
`;
